const Psicologo = () => {
  return <></>
}

export default Psicologo

export const getServerSideProps = async ({ query }) => {
  const queryString = Object.keys(query)
    .filter(key => key !== 'slug')
    .map(key => `${key}=${query[key]}`)
    .join('&')

  return {
    redirect: {
      destination: `/psicologo/${query.slug}/?${queryString}`,
      permanent: true
    },
    props: {}
  }
}
